<template>
  <a
    :href="block.link"
    class="menu-block"
  >
    <responsive-image
      :image="block.image"
      block-class="menu-block"
      min-max="1024-2048"
      ratio="3:2"
    />
    <p
      class="menu-block__title text-body-s"
      v-text="block.title"
    />
    <p
      class="menu-block__subtitle text-body-xs text-body-s-desktop"
      v-text="block.subtitle"
    />
  </a>
</template>

<script>

/**
 * Vue: menu-block (menu-block)
 * -----------------------------------------------------------------------------
 * Menu Blocks eg. Shop By Range.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'MenuBlock',

  components: {
    ResponsiveImage,
  },

  props: {
    block: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss">
@import '@splidejs/vue-splide/css';
@import './menu-block';
</style>
